import React, { Fragment, useState, useEffect } from 'react';
import classnames from 'classnames';
import {
  Row,
  Input,
  Button,
  Card,
  CardBody,
  NavItem,
  CardImg,
  CardSubtitle,
  CardText,
  CardHeader,
  TabContent,
  TabPane,
  Nav,
  CardTitle,
  CustomInput,
  Modal,
  ModalBody,
  ModalFooter,
  NavLink
} from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import publish from '../../../../../../assets/publish.png';
import copilot_publish from '../../../../../../assets/copilot_publish.png';
import dynamic_publish from '../../../../../../assets/dynamic_publish.png';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import PublishModel from './PublishModel';
import InstaLogo from '../../../../../../assets/insta_logo.png';
import MessengerX from '../../../../../../assets/MessengerX.png';
import WhatsApp_Logo from '../../../../../../assets/whatsapp_icon.svg';
import FB_logo from '../../../../../../assets/fb_logo.png';
import Phone_Logo from '../../../../../../assets/phone_logo.png';
import bot_icon from '../../../../../../assets/bot_icon.png';
import copilot_icon from '../../../../../../assets/copilot_icon.png';
import Logs from './Logs';
import {
  gAPI_Publish_Features,
  gAPI_QuestionSets,
  gAPI_Internal_Property_By_Id,
  gAPI_Availability_Publish,
  gAPI_Publish_url,
  gAPI_Context_Document
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { FaExpand } from 'react-icons/fa';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { setBackGroundColor } from '../../../integration/style/DigitalAssistantStyle';
import ViewPublishContent from './ViewPublishContent';

const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
  top:auto !important;
  bottom: 0 !important;
}
/* Style the custom checkboxes */
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color:rgb(188, 192, 192) !important;
  border-color:rgb(188, 192, 192) !important;
  color: white; 
}

.custom-checkbox .custom-control-label::before {
  background-color: #d2d7d7 !important; /* Defaultrgb(188, 192, 192) color */
  border-color:rgb(188, 192, 192) !important;
}

.active{
  background-color:transparent;

}`;
function CardList({ propertyId, locale, domains }) {
  const [result, setResult] = useState([]);
  const [activeTab, setActiveTab] = useState('publish');
  const [type, setType] = useState('Publish');
  const [visible, setVisible] = useState(false);
  const [isCopilot, setIsCopilot] = useState(false);
  const [conversation, setConversation] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [itemCountsData, setItemsCountData] = useState();
  const [isVirtualFrontDesk, setIsVirtualFrontDesk] = useState(false);
  const [context, setContext] = useState([]);
  // const handleDynamicPublish = () => {
  //   setType('Dynamic');
  //   setVisible(!visible);
  // };
  // const handleCopilotPublish = () => {
  //   setType('Copilot');
  //   setVisible(!visible);
  // };
  const [selectedItems, setSelectedItems] = useState([
    {
      type: 'GenAI',
      includeFAQ: false,
      includeKnowledgeHub: false,
      includeDocuments: false,
      includeWebWidgetMenus: false,
      includeDigitalCompendium: false,
      includedProductsAndServices: false,
      includeRoomTypes: false,
      includeForms: false,
    },
    {
      type: 'Copilot',
      includeFAQ: false,
      includeKnowledgeHub: false,
      includeDocuments: false,
    },
    {
      type: 'Dynamic',
      includeFAQ: false,
      includeKnowledgeHub: false,
      includeDocuments: false,
    },
  ]);
  const [isViewPublishBtn, setIsViewPublishBtn] = useState(false);
  const [publishContentUrl, setPublishContentUrl] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch Publish button availbility
        const viewPublish = await AxiosAPI({
          method: 'get',
          url: `${gAPI_Availability_Publish}/${propertyId}`,
        });
        setIsViewPublishBtn(viewPublish.data.url === "exists" ? true : false);
        if (viewPublish.data.url === "exists") {
          const viewcontent = await AxiosAPI({
            method: 'get',
            url: `${gAPI_Publish_url}/${propertyId}`,
          });
          setPublishContentUrl(viewcontent.data.url);
        }
        // Fetch FAQ count
        const faqRes = await AxiosAPI({
          method: 'get',
          url: `${gAPI_Publish_Features}?gid=${getGroupID()}&pid=${propertyId}`,
        });
        setItemsCountData(faqRes.data);
        const compendiumRes = await AxiosAPI({
          method: 'get',
          url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
        });
        if (faqRes?.data) {
          let lst = [...selectedItems];
          if (
            Array.isArray(domains) &&
            domains.length > 0 &&
            !domains.some(
              (item) =>
                item.type &&
                ['UtilityProviders', 'BusinessOperator'].includes(item.type)
            )
          ) {
            selectedItems[0]['includeKnowledgeHub'] = true;
            selectedItems[0].includeRoomTypes =
              faqRes.data?.roomTypesCount && faqRes.data.roomTypesCount > 0
                ? true
                : false;
          }
          selectedItems[0].includeFAQ =
            faqRes.data?.faqCount && faqRes.data.faqCount > 0 ? true : false;
          selectedItems[0].includeDocuments =
            faqRes.data?.documentCount && faqRes.data.documentCount > 0
              ? true
              : false;
          selectedItems[0].includeWebWidgetMenus =
            faqRes.data?.wedWidgetCount && faqRes.data.wedWidgetCount > 0
              ? true
              : false;

          if (compendiumRes.data.isVirtualFrontDesk)
            selectedItems[0].includeDigitalCompendium =
              faqRes.data?.compendiumCount && faqRes.data.compendiumCount > 0
                ? true
                : false;

          selectedItems[0].includedProductsAndServices =
            faqRes.data?.productsAndServicesCount &&
              faqRes.data.productsAndServicesCount > 0
              ? true
              : false;

          console.log(faqRes.data?.includeForms);
          selectedItems[0].includeForms =
            faqRes.data?.formsCount && faqRes.data.formsCount > 0
              ? true
              : false;

          setSelectedItems(lst);
        }

        setIsVirtualFrontDesk(compendiumRes.data.isVirtualFrontDesk);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      const context = await AxiosAPI({
        method: 'get',
        url: `${gAPI_Context_Document}?groupId=${getGroupID()}&propertyId=${propertyId}`,
      });
      setContext(context?.data);
      console.log('context', context.data);
    };

    fetchData();
  }, [propertyId, domains]);

  const handleToggle = () => {
    setVisible(!visible);
  };

  const handleSelectedItems = (index, e) => {
    let lst = [...selectedItems];
    selectedItems[index][e.target.name] = e.target.checked;
    setSelectedItems(lst);
  };

  const handleKnowledgeHub = (e) => {
    let lst = [...selectedItems];
    if (selectedItems[0].includeKnowledgeHub) {
      selectedItems[0][e.target.name] = e.target.checked;
    } else {
      selectedItems[0][e.target.name] = e.target.checked;
      selectedItems[0].includeRoomTypes = e.target.checked;
    }
    setSelectedItems(lst);
  };

  const handleAIPublish = () => {
    // const selectedInclude = selectedItems.some(
    //   (item) =>
    //     item.includeKnowledgeHub ||
    //     item.includeFAQ ||
    //     item.includeDocuments ||
    //     item.includeWebWidgetMenus ||
    //     item.includedProductsAndServices ||
    //     item.includeDigitalCompendium ||
    //     item.includeRoomTypes
    // );

    // if (!selectedInclude) {
    //   NotificationManager.error(
    //     'Please select at least one option to train the AI model.'
    //   );
    // } else {
    setType('Publish');
    setVisible(!visible);
    // }
  };

  useEffect(() => {
    const callLoadResponse = async () => {
      await loadResponse();
    };
    callLoadResponse();
  }, [propertyId]);

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        if (setslist !== null && setslist.length > 0) {
          setslist = setslist.filter(
            (l) => l.type === 'DynamicConversationFlow'
          );
        }
        setResult(setslist);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };

  // const handleDynamicFlow = (e) => {
  //   let obj = result.filter((f) => f.id === e.target.value);
  //   setConversation(obj);
  //   let lst = [...selectedItems];
  //   selectedItems[2].includeFAQ =
  //     obj.length > 0 ? obj[0].flowTrainingData?.includeFAQ : e.target.checked;
  //   selectedItems[2].includeKnowledgeHub =
  //     obj[0].flowTrainingData?.includeKnowledgeData;
  //   selectedItems[2].includeDocuments =
  //     obj[0].flowTrainingData?.includeDocuments;
  //   setSelectedItems(lst);
  // };
  // const toggleModal = (image) => {
  //   setCurrentImage(image);
  //   setModalOpen(!modalOpen);
  // };

  return (
    <Fragment>
      <CardHeader
        className="mb-2"
        style={{ marginLeft: '-1.22rem', marginRight: '-1.22rem' }}
      >
        <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-0 mr-0">
          <style>{style_css}</style>
          <NavItem
            className="text-center"
            style={{ width: 'auto', background: '' }}
          >
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === 'publish',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('publish');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${activeTab === 'publish' ? 'var(--theme-color-1)' : '#8f8f8f'
                    }`,
                  fontWeight: 600,
                }}
              >
                Publish
              </span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === 'logs',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('logs');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${activeTab === 'logs' ? 'var(--theme-color-1)' : '#8f8f8f'
                    }`,
                  fontWeight: 600,
                }}
              >
                Logs
              </span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === 'publish_content',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('publish_content');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${activeTab === 'publish_content' ? 'var(--theme-color-1)' : '#8f8f8f'
                    }`,
                  fontWeight: 600,
                }}
              >
                View Published Content
              </span>
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab} className="">
        <TabPane tabId="publish" className="chat-app-tab-pane">
          <Row className="mb-3">
            <Colxx xxs="12" xs="6" lg="4">
              <Card className="publishai-card">
                <div className="react-card " style={{ color: 'black' }}>
                  {/* <div
                    className="position-relative"
                    style={{ borderBottom: '2px solid #f2f0f0' }}
                  >
                    <CardImg top src={publish} alt="Card image cap" />
                  </div> */}
                  <CardBody className="px">
                    <CardSubtitle className="mb-4">
                      <h3 className="text-black-50">
                        Publish Gen AI Model for AI Chatbot
                      </h3>
                    </CardSubtitle>
                    <Row className="my-3">
                      {Array.isArray(domains) &&
                        domains.length > 0 &&
                        !domains.some(
                          (item) =>
                            item.type &&
                            ['UtilityProviders', 'BusinessOperator'].includes(
                              item.type
                            )
                        ) && (
                          <Colxx xxs="12">
                            <CustomInput
                              type="checkbox"
                              label={'Pre-Built Templates'}
                              checked={true}
                              name="includeKnowledgeHub"
                              onChange={(e) => handleKnowledgeHub(e)}
                              disabled={false}
                              title={
                                'All available knowledge data is used for training the Gen AI Model'
                              }
                            />
                          </Colxx>
                        )}

                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={`FAQs (${itemCountsData?.faqCount === 0
                            ? 'No FAQ'
                            : `${itemCountsData?.faqCount} FAQ${itemCountsData?.faqCount === 1 ? '' : 's'
                            }`
                            })`}
                          checked={
                            selectedItems[0].includeFAQ ||
                            itemCountsData?.faqCount > 0
                          }
                          name="includeFAQ"
                          onChange={(e) => handleSelectedItems(0, e)}
                          disabled={itemCountsData?.faqCount === 0}
                          title={
                            'All available knowledge data is used for training the Gen AI Model'
                          }
                        />
                      </Colxx>
                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={`Documents (${itemCountsData?.documentCount === 0
                            ? 'No Document'
                            : `${itemCountsData?.documentCount} Document${itemCountsData?.documentCount === 1 ? '' : 's'
                            }`
                            })`}
                          checked={
                            selectedItems[0].includeDocuments ||
                            itemCountsData?.documentCount > 0
                          }
                          name="includeDocuments"
                          onChange={(e) => handleSelectedItems(0, e)}
                          disabled={itemCountsData?.documentCount === 0}
                          title={
                            'All available knowledge data is used for training the Gen AI Model'
                          }
                        />
                      </Colxx>

                      {isVirtualFrontDesk && (
                        <Colxx xxs="12">
                          <CustomInput
                            type="checkbox"
                            label={`Digital Compendium (${itemCountsData?.compendiumCount === 0
                              ? 'No Digital Compendium'
                              : `${itemCountsData?.compendiumCount
                              } Digital Compendium${itemCountsData?.compendiumCount === 1
                                ? ''
                                : 's'
                              }`
                              })`}
                            checked={
                              selectedItems[0].includeDigitalCompendium ||
                              itemCountsData?.compendiumCount > 0
                            }
                            name="includeDigitalCompendium"
                            onChange={(e) => handleSelectedItems(0, e)}
                            disabled={itemCountsData?.compendiumCount === 0}
                            title={
                              'All available knowledge data is used for training the Gen AI Model'
                            }
                          />
                        </Colxx>
                      )}

                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={`Web Widget Menus (${itemCountsData?.wedWidgetCount === 0
                            ? 'No Web Widget Menus'
                            : `${itemCountsData?.wedWidgetCount
                            } Web Widget Menu${itemCountsData?.wedWidgetCount === 1
                              ? ''
                              : 's'
                            }`
                            })`}
                          checked={
                            selectedItems[0].includeWebWidgetMenus ||
                            itemCountsData?.wedWidgetCount > 0
                          }
                          name="includeWebWidgetMenus"
                          onChange={(e) => handleSelectedItems(0, e)}
                          disabled={itemCountsData?.wedWidgetCount === 0}
                          title={
                            'All available knowledge data is used for training the Gen AI Model'
                          }
                        />
                      </Colxx>
                      {Array.isArray(domains) &&
                        domains.length > 0 &&
                        !domains.some(
                          (item) =>
                            item.type &&
                            ['UtilityProviders', 'BusinessOperator'].includes(
                              item.type
                            )
                        ) && (
                          <Colxx xxs="12">
                            <CustomInput
                              type="checkbox"
                              label={`Room Types (${itemCountsData?.roomTypesCount === 0
                                ? 'No Room Types'
                                : `${itemCountsData?.roomTypesCount
                                } Room Type${itemCountsData?.roomTypesCount === 1
                                  ? ''
                                  : 's'
                                }`
                                })`}
                              checked={
                                selectedItems[0].includeRoomTypes ||
                                itemCountsData?.roomTypesCount > 0
                              }
                              name="includeRoomTypes"
                              onChange={(e) => handleSelectedItems(0, e)}
                              disabled={itemCountsData?.roomTypesCount === 0}
                              title={
                                'All available knowledge data is used for training the Gen AI Model'
                              }
                            />
                          </Colxx>
                        )}
                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={`Products & Services (${itemCountsData?.productsAndServicesCount === 0
                            ? 'No Products & Services'
                            : `${itemCountsData?.productsAndServicesCount
                            } Products & Service${itemCountsData?.productsAndServicesCount === 1
                              ? ''
                              : 's'
                            }`
                            })`}
                          checked={
                            selectedItems[0].includedProductsAndServices ||
                            itemCountsData?.productsAndServicesCount > 0
                          }
                          name="includedProductsAndServices"
                          onChange={(e) => handleSelectedItems(0, e)}
                          disabled={
                            itemCountsData?.productsAndServicesCount === 0
                          }
                          title={
                            'All available knowledge data is used for training the Gen AI Model'
                          }
                        />
                      </Colxx>
                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={`Forms (${itemCountsData?.formsCount === 0
                            ? 'No Forms'
                            : `${itemCountsData?.formsCount} Form${itemCountsData?.formsCount === 1 ? '' : 's'
                            }`
                            })`}
                          checked={
                            selectedItems[0].includeForms ||
                            itemCountsData?.formsCount > 0
                          }
                          name="includeForms"
                          onChange={(e) => handleSelectedItems(0, e)}
                          disabled={itemCountsData?.formsCount === 0}
                          title={
                            'All available knowledge data is used for training the Gen AI Model'
                          }
                        />
                      </Colxx>
                    </Row>
                    <div className="publish-ai mb-3">
                      <p
                        className="text-muted ml-1 mt-2 mb-1"
                        style={{ fontSize: '11px' }}
                      >
                        {' '}
                        The AI model will be trained using all the checked
                        knowledge sources where data is available.
                      </p>
                      <Button
                        color="primary"
                        size="sm"
                        className="mb-2"
                        onClick={() => handleAIPublish()}
                        style={{ margin: '2px', width: '100%' }}
                        outline
                      >
                        Publish
                      </Button>

                      {isViewPublishBtn &&
                        <div className='text-center'>
                          <span
                            onClick={() => {
                              setActiveTab('publish_content');
                            }}
                            className='text-primary'
                            style={{ textDecoration: 'underline', fontSize: "10px" }}>
                            View Published Content
                          </span>
                        </div>
                      }
                    </div>
                  </CardBody>
                </div>
              </Card>
            </Colxx>
            {/* <Colxx xxs="12" xs="6" lg="4">
             
                  <CardBody className="px">
                    <CardSubtitle className="mb-4">
                      <h3 className="text-black-50">
                        Publish Gen AI Model for Staff Copilot
                      </h3>
                    </CardSubtitle>
                    <Row className="my-3">
                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={'Include Pre-Built Templates'}
                          checked={
                            selectedItems[1].includeKnowledgeHub ? true : false
                          }
                          name="includeKnowledgeHub"
                          onChange={(e) => handleSelectedItems(1, e)}
                        ></CustomInput>
                      </Colxx>
                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={`FAQs (${
                            itemCountsData?.faqCount === 0
                              ? 'No FAQ'
                              : `${itemCountsData?.faqCount} FAQ${
                                  itemCountsData?.faqCount === 1 ? '' : 's'
                                }`
                          })`}
                          checked={selectedItems[1].includeFAQ ? true : false}
                          name="includeFAQ"
                          onChange={(e) => handleSelectedItems(1, e)}
                          disabled={itemCountsData?.faqCount === 0}
                        ></CustomInput>
                      </Colxx>
                      <Colxx xxs="12">
                        <CustomInput
                          type="checkbox"
                          label={`Documents (${
                            itemCountsData?.documentCount === 0
                              ? 'No Document'
                              : `${itemCountsData?.documentCount} Document${
                                  itemCountsData?.documentCount === 1 ? '' : 's'
                                }`
                          })`}
                          checked={
                            selectedItems[1].includeDocuments ? true : false
                          }
                          name="includeDocuments"
                          onChange={(e) => handleSelectedItems(1, e)}
                          disabled={itemCountsData?.documentCount === 0}
                        ></CustomInput>
                      </Colxx>
                    </Row>
                    <div className="publish-ai mb-3">
                      <Button
                        color="primary"
                        size="sm"
                        className="mb-2"
                        style={{ margin: '2px', width: '100%' }}
                        outline
                        //onClick={() => handleCopilotPublish()}
                      >
                        Coming Soon
                      </Button>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </Colxx>
            <Colxx xxs="12" xs="6" lg="4">
            
                  <CardBody className="px">
                    <CardSubtitle className="mb-4">
                      <h3 className="text-black-50">
                        Publish Dynamic Conversation for AI Chatbot
                      </h3>
                    </CardSubtitle>
                    {result.length > 0 ? (
                      <Row className="my-3">
                        <Colxx xxs="12">
                          <div className="d-flex mb-2 mt-2">
                            <Input
                              className="border p-2 mb-3"
                              type="select"
                              name="assistantId"
                              placeholder="Dynamic Conversation Flow"
                              onChange={(e) => handleDynamicFlow(e)}
                            >
                              <option value="">
                                Select a Dynamic Conversation Flow
                              </option>
                              {result.map((assist, index) => (
                                <option key={index} value={assist.id}>
                                  {`${assist.name} (${assist.id})`}
                                </option>
                              ))}
                            </Input>
                          </div>
                        </Colxx>
                        <Colxx xxs="12">
                          <CustomInput
                            type="checkbox"
                            label={'Include Pre-Built Templates'}
                            checked={
                              conversation.length > 0
                                ? conversation[0].flowTrainingData
                                    ?.includeKnowledgeData
                                : false
                            }
                            disabled
                            name="includeKnowledgeHub"
                            //onChange={(e) => handleSelectedItems(2, e)}
                          ></CustomInput>
                        </Colxx>
                        <Colxx xxs="12">
                          <CustomInput
                            type="checkbox"
                            label={`FAQs (${
                              itemCountsData?.faqCount === 0
                                ? 'No FAQs'
                                : `${itemCountsData?.faqCount} FAQs`
                            })`}
                            disabled
                            checked={
                              conversation.length > 0
                                ? conversation[0].flowTrainingData?.includeFAQ
                                : false
                            }
                            name="includeFAQ"
                            //  onChange={(e) => handleSelectedItems(2, e)}
                          ></CustomInput>
                        </Colxx>
                        <Colxx xxs="12">
                          <CustomInput
                            type="checkbox"
                            label={`Documents (${
                              itemCountsData?.documentCount === 0
                                ? 'No Document'
                                : `${itemCountsData?.documentCount} Documents`
                            })`}
                            disabled
                            checked={
                              conversation.length > 0
                                ? conversation[0].flowTrainingData
                                    ?.includeDocuments
                                : false
                            }
                            name="includeDocuments"
                            // onChange={(e) => handleSelectedItems(2, e)}
                          ></CustomInput>
                        </Colxx>
                      </Row>
                    ) : (
                      <Row className="my-3">
                        <Colxx xxs="12">
                          No Dynamic Conversation created yet.
                        </Colxx>
                      </Row>
                    )}
                    {result.length > 0 ? (
                      <div className="publish-ai mb-3">
                        <Button
                          color="primary"
                          size="sm"
                          className="mb-2"
                          onClick={() => handleDynamicPublish()}
                          style={{ margin: '2px', width: '100%' }}
                          outline
                        >
                          Publish
                        </Button>
                      </div>
                    ) : (
                      <div className="publish-ai mb-3">
                        <Button
                          color="primary"
                          size="sm"
                          className="mb-2"
                          onClick={() =>
                            (window.location.href =
                              '/app/pages/propinfo/recommender')
                          }
                          style={{ margin: '2px', width: '100%' }}
                          outline
                        >
                          Create Conversation Flow
                        </Button>
                      </div>
                    )}
                  </CardBody>
                </div>
              </Card>
            </Colxx>*/}
          </Row>
          {/* <Row className="my-2">
            <Colxx xxs="12" xs="6" lg="4">
              <Card
                className=" card"
                style={{ height: '43rem', padding: '10px' }}
              >
                <div
                  className="react-card"
                  style={{ height: '100%', color: 'black' }}
                >
                  <div
                    className="position-relative"
                    style={{ borderBottom: '2px solid #f2f0f0' }}
                  >
                    <CardImg top src={publish} alt="Card image cap" />
                    <div
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        backgroundColor: 'rgba(137, 136, 136, 0.6)',
                        borderRadius: '50%',
                        padding: '4px',
                        cursor: 'pointer',
                      }}
                      onClick={() => toggleModal(publish)}
                    >
                      <FaExpand color="white" size={20} />
                    </div>
                  </div>
                  <CardBody className="px">
                    <CardSubtitle className="mb-4">
                      <h3 className="text-black-50">
                        Gen AI Model for AI Chatbot
                      </h3>
                    </CardSubtitle>
                    <CardText className="mb-2 font-weight-light">
                      <p className="mb-2 publish-font">
                        Transform your Knowledge Hub, including Business
                        Templates, FAQs, and Documents, into a Generative AI
                        model. When a customer asks a question, the model
                        generates a response based on the Knowledge Hub and
                        delivers it to the customer through their original
                        channel.
                      </p>

                      <p className="text-muted text-small my-2">Features</p>
                      <Row className="my-2 mx-0">
                        <div className="publish-features">IMAGES</div>
                        <div className="publish-features">CONTEXT</div>
                        <div className="publish-features">TEXT RESPONSE</div>
                      </Row>
                    </CardText>
                    <CardText className="mb-2">
                      <p className="text-muted text-small mb-2">Channels</p>
                      <div className="d-flex">
                        <img
                          src={MessengerX}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={InstaLogo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={WhatsApp_Logo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={FB_logo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={Phone_Logo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                      </div>
                    </CardText>
                  </CardBody>
                </div>
              </Card>
            </Colxx>
            <Colxx xxs="12" xs="6" lg="4">
              <Card className="" style={{ height: '43rem', padding: '10px' }}>
                <div
                  className="react-card"
                  style={{ height: '100%', color: 'black' }}
                >
                  <div
                    className="position-relative"
                    style={{ borderBottom: '2px solid #f2f0f0' }}
                  >
                    <CardImg top src={copilot_publish} alt="Card image cap" />
                    <div
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        backgroundColor: 'rgba(137, 136, 136, 0.6)',
                        borderRadius: '50%',
                        padding: '4px',
                        cursor: 'pointer',
                      }}
                      onClick={() => toggleModal(copilot_publish)}
                    >
                      <FaExpand color="white" size={20} />
                    </div>
                  </div>
                  <CardBody className="px">
                    <CardSubtitle className="mb-4">
                      <h3 className="text-black-50">
                        Gen AI Model for Staff Copilot
                      </h3>
                    </CardSubtitle>
                    <CardText className="mb-2 font-weight-light">
                      <p className="mb-2 publish-font">
                        Transform your Knowledge Hub, including Business
                        Templates, FAQs, and Documents, into a Generative AI
                        model. Content marked as "Internal Use Only" will also
                        be incorporated into this model. When staff members ask
                        a question via the Myma.ai Agent Assist screen, the
                        model generates a response based on the Knowledge Hub
                        and delivers it directly to the staff member.
                      </p>
                      <p className="text-muted text-small my-2">Features</p>
                      <Row className="my-2 mx-0">
                        <div className="publish-features">IMAGES</div>
                        <div className="publish-features">
                          INTERNAL USE ONLY
                        </div>
                        <div className="publish-features">TEXT RESPONSE</div>
                      </Row>
                    </CardText>
                    <CardText className="mb-2">
                      <p className="text-muted text-small mb-2">Channels</p>
                      <div className="d-flex">
                        <img
                          src={copilot_icon}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                      </div>
                    </CardText>
                  </CardBody>
                </div>
              </Card>
            </Colxx>
            <Colxx xxs="12" xs="6" lg="4">
              <Card className="" style={{ height: '43rem', padding: '10px' }}>
                <div
                  className="react-card"
                  style={{ height: '100%', color: 'black' }}
                >
                  <div
                    className="position-relative"
                    style={{ borderBottom: '2px solid #f2f0f0' }}
                  >
                    <CardImg top src={dynamic_publish} alt="Card image cap" />
                    <div
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        backgroundColor: 'rgba(137, 136, 136, 0.6)',
                        borderRadius: '50%',
                        padding: '4px',
                        cursor: 'pointer',
                      }}
                      onClick={() => toggleModal(dynamic_publish)}
                    >
                      <FaExpand color="white" size={20} />
                    </div>
                  </div>
                  <CardBody className="px">
                    <CardSubtitle className="mb-4">
                      <h3 className="text-black-50">
                        Dynamic Conversation for AI Chatbot
                      </h3>
                    </CardSubtitle>
                    <CardText className="mb-2 font-weight-light">
                      <p className="mb-2 publish-font">
                        With a Conversation Flow, you can add custom
                        instructions in simple everyday language and augment by
                        including training data from Knowledge Hub and invoke
                        external API's. Once you create a Conversation Flow, you
                        can surface it through different channels Myma.ai
                        supports i.e. Website Chat, AI Voice, Facebook
                        Messenger, WhatsApp, and Instagram.
                      </p>

                      <p className="text-muted text-small my-2">Features</p>
                      <Row className="my-2 mx-0">
                        <div className="publish-features">
                          COMPLEX INSTRUCTIONS
                        </div>
                        <div className="publish-features">
                          FOLLOW-UP QUESTIONS
                        </div>
                        <div className="publish-features">CONTEXT</div>
                        <div className="publish-features">API CALLING</div>
                        <div className="publish-features">TEXT RESPONSE</div>
                      </Row>
                    </CardText>
                    <CardText className="mb-2">
                      <p className="text-muted text-small mb-2">Channels</p>
                      <div className="d-flex">
                        <img
                          src={MessengerX}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={InstaLogo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={WhatsApp_Logo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={FB_logo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                        <img
                          src={Phone_Logo}
                          width={20}
                          height={20}
                          className="ml-2"
                        ></img>
                      </div>
                    </CardText>
                  </CardBody>
                </div>
              </Card>
          
              <Modal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                size="lg"
              >
                <ModalBody>
                  <img
                    src={currentImage}
                    alt="Enlarged Image"
                    style={{ width: '100%' }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={() => setModalOpen(false)}>
                    Close
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row> */}
        </TabPane>
        <TabPane tabId="logs" className="chat-app-tab-pane">
          {activeTab === 'logs' && <Logs logType="PublishAI"></Logs>}
        </TabPane>
        <TabPane tabId="publish_content" className="chat-app-tab-pane">
          {activeTab === 'publish_content' &&
            <ViewPublishContent
              contextData={context}
              itemCountsData={itemCountsData}
              publishContentUrl={publishContentUrl}>
            </ViewPublishContent>}
        </TabPane>
      </TabContent>
      {visible && (
        <PublishModel
          selectedItems={selectedItems}
          toggleModal={handleToggle}
          visible={visible}
          type={type}
          convesationId={conversation.length > 0 ? conversation[0].id : ''}
          result={result}
        ></PublishModel>
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email, domains } = settings;
  return {
    propertyId,
    locale,
    email,
    domains,
  };
};

export default injectIntl(connect(mapStateToProps)(CardList));
